import { Tooltip, TooltipProps } from '@mui/material';

import { forwardRef } from 'react';

interface IProps extends TooltipProps {
  disabled?: boolean;
}

export const ConvergeTooltip = forwardRef(
  ({ disabled, ...props }: IProps, ref) =>
    disabled ? (
      props.children
    ) : (
      <Tooltip
        slotProps={{
          tooltip: {
            sx: {
              width: '200px', // Fixed width container
              display: 'flex',
              alignItems: 'center', // Vertical centering
              justifyContent: 'center', // Horizontal centering
              backgroundColor: '#333333',
              borderRadius: '3px',
              color: 'white',
              fontSize: '12px',
              fontWeight: '600',
              padding: '10px',
              margin: '0 auto', // Center the container itself
            },
          },
        }}
        {...props}
        ref={ref}
      />
    )
);
